import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {}
